var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.965,
    height: 17.643,
    viewBox: "0 0 35.965 17.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-graduation-2138315",
    transform: "translate(-81.917 -148.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11457",
    "data-name": "Path 11457",
    d: "M99.266,159.02a.639.639,0,0,1-.117-.015L82.24,154.3a.441.441,0,0,1,0-.85l11.439-3.186a.441.441,0,1,1,.234.849L84,153.872l15.269,4.247,15.262-4.247-15.269-4.255-3.413.952a.441.441,0,0,1-.234-.85l3.537-.981a.424.424,0,0,1,.234,0l16.9,4.709a.441.441,0,0,1,0,.85l-16.9,4.7a.332.332,0,0,1-.117.022Z",
    fill: "#f5c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11458",
    "data-name": "Path 11458",
    d: "M204.89,261.382a28,28,0,0,1-6.708-.769c-2.036-.52-3.061-1.128-3.061-1.816v-1.274a.439.439,0,1,1,.879,0v1.23c.11.154.769.615,2.68,1.076a27.45,27.45,0,0,0,6.21.674,27.925,27.925,0,0,0,6.21-.674c1.926-.461,2.585-.93,2.68-1.076v-7.177l-8.773,2.446a.425.425,0,0,1-.234,0L196,251.576V253.3a.439.439,0,1,1-.879,0V251a.448.448,0,0,1,.176-.352.443.443,0,0,1,.381-.073l9.212,2.563,9.212-2.563a.443.443,0,0,1,.381.073.437.437,0,0,1,.176.352v7.792a.25.25,0,0,1-.007.073c-.073.659-1.1,1.245-3.061,1.743a27.873,27.873,0,0,1-6.7.776Zm-9.33-5.661a.441.441,0,0,1-.439-.439v-.308a.439.439,0,1,1,.879,0v.308A.441.441,0,0,1,195.561,255.721Z",
    transform: "translate(-105.624 -95.017)",
    fill: "#f5c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11459",
    "data-name": "Path 11459",
    d: "M351.826,227.965a.441.441,0,0,1-.439-.439l-.007-7.565h-12.83a.439.439,0,1,1,0-.879h13.263a.441.441,0,0,1,.439.439l.015,8a.441.441,0,0,1-.439.439Zm-15.489-8h-1.428a.439.439,0,0,1,0-.879h1.428a.439.439,0,1,1,0,.879Z",
    transform: "translate(-235.642 -65.65)",
    fill: "#f5c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11460",
    "data-name": "Path 11460",
    d: "M571.068,273.681a.441.441,0,0,1-.439-.439v-3.457a.827.827,0,1,0-1.655,0v3.457a.439.439,0,0,1-.879,0v-3.457a1.706,1.706,0,0,1,3.413,0v3.457A.441.441,0,0,1,571.068,273.681Z",
    transform: "translate(-453.625 -111.365)",
    fill: "#f5c6c6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudy);
export default __webpack_public_path__ + "static/media/study.b4b6f0894cd6835f819fb2bfbf3d26dc.svg";
export { ForwardRef as ReactComponent };